import React from "react";
import styles from "./DeliveryOptions.module.css";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

interface DeliveryOptionsProps {
  expressAvailable: boolean;
  expressCountdown: string | null;
  expressNextAvailable?: string | null;
  rapidoDateRange: string | null;
  standardStartDate: string | null;
  rapidoCountdown: string | null;
  standardCountdown: string | null;
}

const DeliveryOptions: React.FC<DeliveryOptionsProps> = ({
  expressAvailable,
  expressCountdown,
  expressNextAvailable,
  rapidoDateRange,
  standardStartDate,
  rapidoCountdown,
  standardCountdown,
}) => {
  return (
    <div className={styles.deliveryOptions}>
      <h3 className={styles.deliveryOptionsTitle}>
        Opciones de entrega disponibles
      </h3>
      <div className={styles.deliveryCards}>
        {/* Express Delivery Card */}
        <div
          className={`${styles.deliveryCard} ${
            expressAvailable ? styles.active : styles.inactive
          }`}
        >
          <div className={styles.deliveryHeader}>
            <FlashOnOutlinedIcon className={styles.deliveryIcon} />
            <div>
              <h3 className={styles.deliveryTitle}>Express</h3>
              <span className={styles.deliveryDescription}>
                Recíbelo en menos de 3 horas
              </span>
            </div>
          </div>
          {expressAvailable && expressCountdown ? (
            <p className={styles.deliveryDateRange}>
              Te quedan {expressCountdown}
            </p>
          ) : expressNextAvailable ? (
            <p className={styles.deliveryUnavailable}>{expressNextAvailable}</p>
          ) : (
            <p className={styles.deliveryUnavailable}>No disponible</p>
          )}
        </div>

        {/* Rápido Delivery Card */}
        <div
          className={`${styles.deliveryCard} ${
            rapidoDateRange ? styles.active : styles.inactive
          }`}
        >
          <div className={styles.deliveryHeader}>
            <LocalShippingOutlinedIcon className={styles.deliveryIcon} />
            <div>
              <h3 className={styles.deliveryTitle}>Rápido</h3>
              <span className={styles.deliveryDescription}>
                Recíbelo en máximo 2 días hábiles
              </span>
            </div>
          </div>
          {rapidoDateRange ? (
            <p className={styles.deliveryDateRange}>{rapidoDateRange}</p>
          ) : (
            <p className={styles.deliveryUnavailable}>No disponible</p>
          )}
          {rapidoCountdown && (
            <p className={styles.deliveryCountdown}>{rapidoCountdown}</p>
          )}
        </div>

        {/* Standard Delivery Card */}
        <div
          className={`${styles.deliveryCard} ${
            standardStartDate && standardStartDate !== "No disponible"
              ? styles.active
              : styles.inactive
          }`}
        >
          <div className={styles.deliveryHeader}>
            <CalendarTodayOutlinedIcon className={styles.deliveryIcon} />
            <div>
              <h3 className={styles.deliveryTitle}>Standard</h3>
              <span className={styles.deliveryDescription}>
                Programa tu pedido :)
              </span>
            </div>
          </div>
          {standardStartDate && standardStartDate !== "No disponible" ? (
            <p className={styles.deliveryDateRange}>{standardStartDate}</p>
          ) : (
            <p className={styles.deliveryUnavailable}>No disponible</p>
          )}
          {standardCountdown && (
            <p className={styles.deliveryCountdown}>{standardCountdown}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryOptions;
